// src/api/authcorte.js

// =============== Base de API robusta ===============
const API_BASE =
  (process.env.REACT_APP_API_URL &&
    process.env.REACT_APP_API_URL.replace(/\/+$/, '')) ||
  (window.location.hostname === 'localhost'
    ? 'http://localhost:3000'
    : window.location.origin);
    

function getStoredToken() {
  return (
    localStorage.getItem('token') ||
    localStorage.getItem('accessToken') ||
    sessionStorage.getItem('token') ||
    sessionStorage.getItem('accessToken') ||
    null
  );
}

function buildHeaders(userHeaders = {}) {
  const h = new Headers(userHeaders);
  if (!h.has('Accept')) h.set('Accept', 'application/json');
  const token = getStoredToken();
  if (token) {
    if (!h.has('Authorization')) h.set('Authorization', `Bearer ${token}`);
    if (!h.has('x-access-token')) h.set('x-access-token', token);
  }
  return h;
}

async function parseResponseOrThrow(res) {
  const url = res.url || '';
  const status = `${res.status} ${res.statusText}`.trim();
  const ct = (res.headers.get('content-type') || '').toLowerCase();
  const raw = await res.text();
  const isJson = ct.includes('application/json');

  if (!res.ok) {
    if (isJson) {
      let data;
      try {
        data = JSON.parse(raw);
      } catch (e) {
        throw new Error(`Error ${status}: JSON malformado de ${url}. Raw: ${raw.slice(0, 100)}`);
      }
      throw new Error(data.message || data.mensaje || `Error de API ${status} en ${url}`);
    } else {
      throw new Error(`Error de red ${status} en ${url}. Respuesta: ${raw.slice(0, 100)}`);
    }
  }

  if (isJson) {
    try {
      return JSON.parse(raw);
    } catch (e) {
      return {}; 
    }
  }
  return raw;
}

async function request(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    credentials: 'include',
    headers: buildHeaders(options.headers),
  });
  return parseResponseOrThrow(res);
}
// =============== Fin Helpers de auth y request ===============

export async function getCortes() {
  return request('/api/cortes/list');
}

export async function createCorte(corteData) {
  return request('/api/cortes/create', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(corteData),
  });
}

export async function updateCorte(corteId, corteData) {
  return request(`/api/cortes/update/${encodeURIComponent(corteId)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(corteData),
  });
}

export async function deleteCorte(corteId) {
  return request(`/api/cortes/delete/${encodeURIComponent(corteId)}`, {
    method: 'DELETE',
  });
}

export async function getCorteById(corteId) {
  return request(`/api/cortes/view/${encodeURIComponent(corteId)}`);
}

// Obtener resumen de cortes por sucursal y mes
export async function getResumenPorSucursal(year, month) {
  console.log('API getResumenPorSucursal:', { year, month });
  const result = await request(`/api/cortes/resumen/por-sucursal/${year}/${month}`);
  console.log('API getResumenPorSucursal response:', result);
  return result;
}

// Obtener resumen total de todas las sucursales por mes
export async function getResumenTotal(year, month) {
  console.log('API getResumenTotal:', { year, month });
  const result = await request(`/api/cortes/resumen/total/${year}/${month}`);
  console.log('API getResumenTotal response:', result);
  return result;
}

// Crear corte con archivos adjuntos
// 🚨 CORRECCIÓN: Ahora solo acepta el FormData
export async function createCorteWithFiles(formData) {
  const token = getStoredToken();
  if (!token) {
    throw new Error('Token de autenticación no encontrado');
  }
  
  console.log('📤 Enviando FormData para creación con archivos');

  const response = await fetch(`${API_BASE}/api/cortes/with-files`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      // El navegador maneja el Content-Type para FormData
    },
    body: formData
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ mensaje: 'Error del servidor' }));
    throw new Error(errorData.mensaje || `Error ${response.status}`);
  }

  return response.json();
}

// Actualizar corte con archivos adjuntos
// 🚨 CORRECCIÓN: Ahora solo acepta el corteId y el FormData
export async function updateCorteWithFiles(corteId, formData) {
  const token = getStoredToken();
  if (!token) {
    throw new Error('Token de autenticación no encontrado');
  }

  console.log('📤 Enviando FormData para actualización de corte:', corteId);

  const response = await fetch(`${API_BASE}/api/cortes/with-files/${encodeURIComponent(corteId)}`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
      // El navegador maneja el Content-Type para FormData
    },
    body: formData
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({ mensaje: 'Error del servidor' }));
    throw new Error(errorData.mensaje || `Error ${response.status}`);
  }

  return response.json();
}
